import React, { useEffect, useState } from "react";

import ReactPaginate from "react-paginate";

import ChevronLeftIcon from "../../assets/icons/ChevronLeftIcon";
import ChevronRightIcon from "../../assets/icons/ChevronRightIcon";
import Table from "./Table";
import { reExecuteSql } from "../../api/messageApi";
import { downloadFile, getNormalizeApiData } from "../Chat/utils";
import SolidSpinnerIcon from "../../assets/icons/SolidSpinnerIcon";
import DownloadIcon from "../../assets/icons/DownloadIcon";
import SolidWarningIcon from "../../assets/icons/SolidWarningIcon";

const ChatTable = ({
  download = true,
  data,
  table_type,
  msgId,
  itemsPerPage = 10,
}) => {
  const columns = Object.keys(data);
  const numberOfEnteries = data[columns[0]].length;
  const [isDownloadFileLoading, setIsDownloadFileLoading] = useState(false);

  const [rows, setRows] = useState(() => {
    let arr = [];
    for (let i = 0; i < numberOfEnteries; i++) {
      const obj = {};
      for (const key in data) {
        let val = data[key][i];
        obj[key] = val;
      }
      arr = [...arr, obj];
    }
    return arr;
  });

  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;

    setCurrentItems(rows.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(rows.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, rows]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % rows.length;
    setItemOffset(newOffset);
  };

  const handleSort = ({ column, sortBy }) => {
    setRows((prev) => {
      const sortedArr = [...prev];
      return sortedArr.sort((a, b) => {
        if (a[column] > b[column]) {
          return sortBy ? 1 : -1;
        } else {
          return sortBy ? -1 : 1;
        }
      });
    });
    setItemOffset(0);
  };

  const handleDownload = async () => {
    if (isDownloadFileLoading) return;

    setIsDownloadFileLoading(true);
    const apiData = await reExecuteSql(msgId);
    const normalizeApiData = getNormalizeApiData(apiData[0]?.table?.dataframe);
    downloadFile({ normalizeApiData });
    setIsDownloadFileLoading(false);
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="flex justify-between items-center">
        {table_type === "data_too_large" ? (
          <div className="flex gap-2 text-xs">
            <div className="p-1.5 rounded-full bg-zinc-700">
              <SolidWarningIcon className="w-5 h-5 text-orange-300" />
            </div>
            <div>
              <div>Incomplete data is displayed.</div>
              <div className="text-zinc-400">
                <button
                  onClick={handleDownload}
                  className="text-blue-500 font-medium"
                >
                  Download
                </button>{" "}
                <span>to view the full dataset.</span>
              </div>
            </div>
          </div>
        ) : null}
        {download ? (
          <button
            onClick={handleDownload}
            className="flex text-sm gap-2 duration-300 text-zinc-400 items-center hover:text-zinc-50 hover:bg-zinc-700 px-4 py-2 rounded-lg"
          >
            {isDownloadFileLoading ? (
              <SolidSpinnerIcon className="w-4 h-4 animate-spin" />
            ) : (
              <DownloadIcon className="w-4 h-4" />
            )}
            <span>Download</span>
          </button>
        ) : null}
      </div>
      <div className="flex flex-col gap-2">
        <div className="overflow-auto rounded-md">
          <Table
            handleSort={handleSort}
            rows={currentItems}
            columns={columns}
          />
        </div>
        <div className={`flex gap-2 items-center text-sm justify-end`}>
          <div
            className={`flex gap-2 items-center text-sm justify-between w-full`}
          >
            <div className="text-xs text-zinc-400">
              Showing{" "}
              <span className="font-semibold">
                {itemOffset + 1}-
                {rows.length < itemsPerPage + itemOffset
                  ? rows.length
                  : itemsPerPage + itemOffset}
              </span>{" "}
              of <span className="font-semibold">{rows.length}</span> rows
            </div>
            <ReactPaginate
              key={JSON.stringify(rows)}
              nextLabel={
                <div className="select-none flex items-center duration-300 cursor-pointer h-8 rounded-lg">
                  <span>Next</span>
                  <ChevronRightIcon className="w-5 h-5" />
                </div>
              }
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              pageCount={pageCount}
              previousLabel={
                <div className="select-none flex items-center duration-300 cursor-pointer h-8 rounded-lg">
                  <ChevronLeftIcon className="w-5 h-5" />
                  <span>Previous</span>
                </div>
              }
              pageClassName="hover:bg-zinc-700 h-8 w-8 duration-300 text-sm rounded-md  border border-transparent flex items-center justify-center"
              pageLinkClassName="h-full w-full flex justify-center items-center"
              previousClassName="select-none h-8"
              previousLinkClassName="h-full w-full flex items-center duration-300 cursor-pointer justify-center hover:bg-zinc-700 pl-2 pr-3 rounded-lg"
              nextClassName="select-none h-8"
              nextLinkClassName="h-full w-full flex items-center justify-center duration-300 cursor-pointer hover:bg-zinc-700 pl-3 pr-2 rounded-lg"
              breakLabel="..."
              breakClassName="text-white h-8 w-5 flex justify-center"
              breakLinkClassName="h-8 w-5 flex items-center justify-center"
              containerClassName="flex gap-1"
              activeClassName="border border-zinc-700 hover:bg-transparent"
              renderOnZeroPageCount={null}
              disabledLinkClassName="disabled-pagination opacity-60"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatTable;
